import { get } from './base';
import constants from '../../config/constants';

export const getMethod = (endpoind,params) => {
    const url = constants.BASE_URL + endpoind;
    return get(url,params);
};
